/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CtmsCategoryRespVo } from './CtmsCategoryRespVo';
import {
    CtmsCategoryRespVoFromJSON,
    CtmsCategoryRespVoFromJSONTyped,
    CtmsCategoryRespVoToJSON,
    CtmsCategoryRespVoToJSONTyped,
} from './CtmsCategoryRespVo';

/**
 * 
 * @export
 * @interface PageDataCtmsCategoryRespVo
 */
export interface PageDataCtmsCategoryRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCtmsCategoryRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCtmsCategoryRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCtmsCategoryRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CtmsCategoryRespVo>}
     * @memberof PageDataCtmsCategoryRespVo
     */
    records?: Array<CtmsCategoryRespVo>;
}

/**
 * Check if a given object implements the PageDataCtmsCategoryRespVo interface.
 */
export function instanceOfPageDataCtmsCategoryRespVo(value: object): value is PageDataCtmsCategoryRespVo {
    return true;
}

export function PageDataCtmsCategoryRespVoFromJSON(json: any): PageDataCtmsCategoryRespVo {
    return PageDataCtmsCategoryRespVoFromJSONTyped(json, false);
}

export function PageDataCtmsCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCtmsCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CtmsCategoryRespVoFromJSON)),
    };
}

export function PageDataCtmsCategoryRespVoToJSON(json: any): PageDataCtmsCategoryRespVo {
    return PageDataCtmsCategoryRespVoToJSONTyped(json, false);
}

export function PageDataCtmsCategoryRespVoToJSONTyped(value?: PageDataCtmsCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CtmsCategoryRespVoToJSON)),
    };
}

